module.exports = __webpack_public_path__ + "img/数据同步.94e7196f.svg";